import { Box } from "@mui/material";
import { EventSession, Id,} from "../../interfaces/types";
import { SortableContext, useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities"
import { FC, useMemo } from "react";
import EventSessionContainer from "./eventSessionContainer";

interface Props {
    eventSessions: EventSession[];
    deleteEventSessionFromRoom: (eventSessionId: Id) => void;
    updateSessionTitle: (eventSessionId: Id, title: string) => void;
    updateSessionDuration: (eventSessionId: Id, duration: number) => void;
}

const UnassignedSessionBox: FC<Props> = (props) => {
    const {deleteEventSessionFromRoom, eventSessions, updateSessionTitle, updateSessionDuration} = props;
    const eventSessionIds = useMemo(() => eventSessions.map((eventSession) => eventSession.id), [eventSessions]);

    const {setNodeRef, attributes, listeners,
        transform, transition} = useSortable({
        id: "unassignedArea",
        data:{
            type: "unassigned",
        }
    });

    const style = {
        transition,
        transform: CSS.Transform.toString(transform),
    };

  return (
    <Box 
        ref={setNodeRef}
        style={style}
        {...attributes}
        {...listeners}
            sx={{height: "100%", width: "100%"}}>

            <SortableContext items={eventSessionIds}>
                {eventSessions.map((eventSession) => (
                    <EventSessionContainer 
                        key={eventSession.id} 
                        eventSession={eventSession}
                        deleteEventSession={deleteEventSessionFromRoom}
                        updateSessionTitle={updateSessionTitle}
                        updateSessionDuration={updateSessionDuration}
                        />
                ))}
            </SortableContext>
    </Box>
  )
}

export default UnassignedSessionBox;